module.exports = __webpack_public_path__ + "img/sprites.fefe1d7b.svg";